"use client";

import { useEffect } from "react";
import { trackException } from "@utils/exceptionTracker";

interface ReviewPageExceptionTrackerProps {
  cityName: string;
  brandName: string;
  modelName: string;
  pageType: string;
  dataChecks: {
    expertRating?: any;
    similarCars?: any[];
    sameBrandCars?: any[];
    structuredArticles?: any[];
    videoArticlesIds?: any[];
  };
  carAvailability?: string;
}

export default function ReviewPageExceptionTracker({
  cityName,
  brandName,
  modelName,
  pageType,
  dataChecks,
  carAvailability,
}: ReviewPageExceptionTrackerProps) {
  useEffect(() => {
    const trackExceptions = async () => {
      const commonProps = {
        city_name: cityName,
        vehicle_make: brandName,
        vehicle_model: modelName,
        car_availability: carAvailability,
      };

      // Expert rating check
      if (!dataChecks?.expertRating) {
        await trackException(
          "data_issue",
          "expert_rating_unavailable",
          pageType,
          commonProps
        );
      }

      // Similar cars check
      if (!dataChecks?.similarCars?.length) {
        await trackException(
          "section_unavailable",
          "similar_car_unavailable",
          pageType,
          commonProps
        );
      }

      // Same brand cars check
      if (!dataChecks?.sameBrandCars?.length) {
        await trackException(
          "section_unavailable",
          "brand_car_unavailable",
          pageType,
          commonProps
        );
      }
    };

    trackExceptions().catch(console.error);
  }, [cityName, brandName, modelName, pageType, dataChecks, carAvailability]);

  return null;
} 